import ownerDocument from "../ownerDocument/index.mjs";
export default function ownerWindow(node) {
  const doc = ownerDocument(node);
  return doc.defaultView || window;
}